/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import clsx from "clsx";
import Select from "react-select";
import PropTypes from "prop-types";
import { store } from 'src/redux';
import { useNavigate } from "react-router-dom";
import { reuploadedData } from "src/redux/features/reuploadData";
import useAuthorizationContext from "src/providers/AuthorizationHandler/useAuthorizationContext";

import styles from "./CustomTab.module.scss";

import { DatePicker, SearchBar, Button } from "src/components";
import { baseApiCall } from "src/api/Api";
import { access_service } from "src/constants/url";
import { constants } from "src/constants/constant";
import {
  Linelist,
  Shoplist,
  filterDates,
  filterLineName,
  filterShopName,
} from "src/redux/features";
import { FormControlLabel } from "@mui/material";
import { useDispatch } from "react-redux";
import Stack from "@mui/material/Stack";
import { AlertsCustomSwitch } from "src/constants/utils";
import CheckBox from "../CheckBox/CheckBox";
import { commonVaribles } from "src/constants/constVariables";
import { colors } from "src/assets/scss/partials/colors";
import { hasEditAccess } from "src/authorization/authorizationsConstants";

export const CustomTab = ({
  classNames = {},
  count,
  title,
  isSelected,
  handleClick,
  countColor,
  withOutCount,
  withOutFilters,
  isDatepicker,
  isDropdown,
  isCheckbox,
  onChangeDatefilter,
  onCheckboxChange,
  isAlerts,
  handleChange,
  toggleState = false,
  notemsg,
  noteforMES,
  setSearchQuery,
  searchQuery,
  searchValueFetch,
  isSubTitleText,
  subTitleText,
  isFeedbackButton,
  setReuploadData,
  setIsFeedBackModalOpen,
  dateClearFilter,
  isSearchBar,
  startDate,
  endDate,
  isPlantName,
  allPlants,
  setAllPlant

}) => {
  const dispatch = useDispatch();
  const { user } = useAuthorizationContext();
  const navigate = useNavigate();
  const defaultShopValue = { label: "All", value: "", type: "shop" };

  const defaultLineValue = { label: "All", value: "", type: "line" };

  const [selectedValue, setSelectedValue] = useState({
    checked: toggleState,
    value: toggleState
      ? commonVaribles.vc_not_mapped
      : commonVaribles.all_alerts,
  });
  // const [shopData, setShopData] = useState([defaultShopValue]);
  // const [lineData, setLineData] = useState([defaultLineValue]);
  const [select, setSelect] = useState({});

  const handleCheckboxChange = (event) => {
    onCheckboxChange(event);
  };

  // useEffect(() => {
  //   if (!withOutFilters) {
  //     fetchShoptList();
  //   }
  //   // dispatch(filterDates([]));
  // }, [select?.shop]);

  // useEffect(() => {
  //   if (!withOutFilters && !isDropdown) {
  //     fetchLineList();
  //   }
  // }, [select?.line]);

  useEffect(() => {
    if (!select?.shop) {
      dispatch(filterShopName());
    }
    if (!select?.line) {
      dispatch(filterLineName());
    }
  }, [select]);

  const fetchShoptList = () => {
    // baseApiCall({
    //   url: access_service.GET_SHOP_LIST,
    //   requestBody: {},
    //   method: commonVaribles.post,
    //   onSuccess: (res) => {
    //     if (res && res.data && res.data.result && res.data.result !== "") {
    //       const data = res.data.result;
    //       setShopData([defaultShopValue, ...data]);
    //       dispatch(Shoplist(data));
    //     }
    //   },
    //   onFailure: () => {},
    //   errorCall: () => {},
    // });
  };

  const fetchLineList = () => {
    // baseApiCall({
    //   url: access_service.GET_LINE_LIST,
    //   requestBody: {
    //     shop_id: select?.shop ? select?.shop?.value : "",
    //   },
    //   method: commonVaribles.post,
    //   onSuccess: (res) => {
    //     if (res && res.data && res.data.result && res.data.result !== "") {
    //       const data = res.data.result;
    //       setLineData(() => [defaultLineValue, ...data]);
    //       dispatch(Linelist(data));
    //     }
    //   },
    //   onFailure: () => {},
    //   errorCall: () => {},
    // });
  };
  const classForTabWrapper = isSelected ? styles.selected : styles.notSelected;

  const possibleColors = ["blue", "red"];
  const classForCount =
    possibleColors.includes(countColor) && countColor === "red"
      ? styles.redCount
      : styles.blueCount;

  const setSelectData = (event) => {
    if (event.type === "line") {
      dispatch(filterLineName(event));
      setSelect({ ...select, [event.type]: event });
    } else if (event.type === "shop") {
      if (select.line && select.line.value !== defaultLineValue.value) {
        // setLineData();
        dispatch(filterLineName(defaultLineValue));
        dispatch(filterShopName(event));
        setSelect({ ...select, line: defaultLineValue, [event.type]: event });
      } else {
        dispatch(filterShopName(event));
        setSelect({ ...select, line: defaultLineValue, [event.type]: event });
      }
    } else {
      setSelect();
    }
  };
  const handleSwitchChange = (event) => {
    const newValue = event.target.checked;
    handleChange(newValue);
    var selectedValue = newValue
      ? commonVaribles.vc_not_mapped
      : commonVaribles.all_alerts;
    setSelectedValue({ checked: newValue, value: selectedValue });
  };

  const redirectToReupload = () => {
    navigate('/packaging-strategy/update-strategy');
    dispatch(reuploadedData(setReuploadData));
  }

  return (
    <div className={styles.headerwithcount}>
      <div className={styles.countwithtitle}>
        <div
          className={clsx(
            !classNames.tabWrapper ? styles.tabWrapper : classNames.tabWrapper,
            classForTabWrapper
          )}
          onClick={handleClick}
          onKeyDown={handleClick}
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer", outline: "none", height: "100%" }}
        >
          <div className={styles.countTitleWrapper}>
            <span
              className={clsx(
                styles.title,
                isSelected ? classNames.selected : classNames.notSelected
              )}
            >
              {title}
            </span>
            {!withOutCount && (
              <span aria-label={`${title}-count`} className={classForCount}>
                {count}
              </span>
            )}
          </div>
        </div>
      </div>

      {/* Old Search START  */}

      {/* <div
        style={notemsg ? { justifyContent: "end" } : {}}
        className={styles.headerdivwithfunctionality}
      >
        {withOutFilters || (
          <>
            <div className={styles.headerchild}>
              <div className={styles.selectlabal}>Select</div>
              <div className={styles.filterView}>
                <div className={styles["select-option"]}>
                  <span className={styles["shop-select"]}>Shop Name</span>
                  <Select
                    options={shopData}
                    isSearchable={false}
                    value={select?.shop ? select?.shop : defaultShopValue}
                    className={styles["dropdown-width"]}
                    onChange={setSelectData}
                    styles={{
                      menuList: (provided) => ({
                        ...provided,
                        "&::-webkit-scrollbar": {
                          width: "4px !important",
                          height: "6px",
                          display: "block !important",
                          background: "none",
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "none",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          background: colors.light_gray,
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          background: colors.dropdown_scroll,
                        },
                      }),
                    }}
                  />
                </div>
                {!isDropdown && (
                  <>
                    <div className={styles["select-option"]}>
                      <span className={styles["shop-select"]}>Line Name</span>
                      <Select
                        options={lineData}
                        isSearchable={false}
                        value={select?.line ? select?.line : defaultLineValue}
                        className={styles["dropdown-width"]}
                        onChange={setSelectData}
                        styles={{
                          menuList: (provided) => ({
                            ...provided,
                            "&::-webkit-scrollbar": {
                              width: "4px !important",
                              height: "6px",
                              display: "block !important",
                              background: "none",
                            },
                            "&::-webkit-scrollbar-track": {
                              background: "none",
                            },
                            "&::-webkit-scrollbar-thumb": {
                              background: colors.light_gray,
                            },
                            "&::-webkit-scrollbar-thumb:hover": {
                              background: colors.dropdown_scroll,
                            },
                          }),
                        }}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className={styles.calenderAndAlerts}>
              {isAlerts && (
                <Stack direction="row" spacing={1} alignItems="center">
                  <span
                    className={
                      selectedValue?.value === commonVaribles.all_alerts
                        ? styles.boldTogleText
                        : styles.normalTogleText
                    }
                  >
                    All alerts
                  </span>
                  <FormControlLabel
                    control={
                      <AlertsCustomSwitch
                        checked={selectedValue?.checked}
                        onChange={handleSwitchChange}
                      />
                    }
                  />
                  <span
                    className={
                      selectedValue?.value === commonVaribles.vc_not_mapped
                        ? styles.boldTogleText
                        : styles.normalTogleText
                    }
                  >
                    VC not mapped
                  </span>
                </Stack>
              )}
              {isDatepicker && (
                <>
                  {noteforMES && (
                    <span className={styles["note"]}>
                      Last MES sync : {noteforMES}
                    </span>
                  )}
                  <div className={styles.datePickerStyle}>
                    <DatePicker onChange={onChangeDatefilter} />
                  </div>
                </>
              )}
            </div>

            {isCheckbox && (
              <div className={styles.checkboxContainer}>
                <CheckBox onChange={handleCheckboxChange} />
                <span className={styles.VcTitle}>Non Mapped VC's</span>
              </div>
            )}
          </>
        )}
        {notemsg && <span className={styles["note"]}>{notemsg}</span>}
      </div> */}

      {/* Old Search END  */}

      <div
        style={notemsg ? { justifyContent: "end" } : {}}
        className={styles.headerdivwithfunctionality}
      >
        {isSubTitleText && (
          <div className={styles.countTitleWrapper}>
            <span
              className={clsx(
                styles.title,
                isSelected ? classNames.selected : classNames.notSelected
              )}
            >
              {subTitleText}
            </span>
            {!withOutCount && (
              <span aria-label={`${title}-count`} className={classForCount}>
                {count}
              </span>
            )}
          </div>
        )}
        {isFeedbackButton || setReuploadData?.Strategies_table?.overall_approval_status == 'rejected' ? (
          <div className={styles.btnOptionSection}>
            {setReuploadData?.Strategies_table?.overall_approval_status == 'rejected'
              && hasEditAccess(user, commonVaribles.update_packaging_strategy) && (
              <div className={styles.tableFooter}>
                <Button
                  children={commonVaribles.reupload}
                  variant={constants.BUTTON_ATOMIC_COMPONENT.SECONDARY}
                  onClick={() => {
                    redirectToReupload();
                  }}
                />
              </div>
            )}
            {isFeedbackButton && (
              <div className={styles.tableFooter}>
                <Button
                  children={commonVaribles.feedback}
                  variant={constants.BUTTON_ATOMIC_COMPONENT.PRIMARY}
                  onClick={() => {
                    setIsFeedBackModalOpen(true);
                  }}
                />
              </div>
            )}
          </div>
				) : (
					<></>
				)}
        {withOutFilters || (
          <>
            <div className={styles.headerchild}>
              {isSearchBar && (
                <div className={styles.filterView}>
                  <div className={styles["select-option"]}>
                    {/* <span className={styles["shop-select"]}></span> */}
                    <div className={styles["search-bar"]}>
                      <SearchBar
                        listingSearch={true}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                        placeHolder="Search by Part Number, Vendor Code, and Supplier Name."
                        searchValueFetch={searchValueFetch}
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className={styles.calenderAndAlerts}>
              {isPlantName && (
                <span className={styles.plantDropdown}>
                  <Select
                    defaultValue={store.getState().allPlants.plantName}
                    isDisabled={false}
                  />
                </span>
              )}
              {isCheckbox && (
                <div className={styles.checkboxContainer}>
                  <CheckBox
                    checked={allPlants}
                    onChange={() => setAllPlant(!allPlants)}
                  />
                  <span className={styles.VcTitle}>All Plants </span>
                </div>
              )}
              {isDatepicker && (
                <>
                  {noteforMES && (
                    <span className={styles["note"]}>
                      Last MES sync : {noteforMES}
                    </span>
                  )}
                  <div className={styles.datePickerStyle}>
                    <DatePicker
                      onChange={onChangeDatefilter}
                      isDateClearFilter={true}
                      dateClearFilter={dateClearFilter}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                </>
              )}
            </div>
          </>
        )}
        {notemsg && <span className={styles["note"]}>{notemsg}</span>}
      </div>
    </div>
  );
};

CustomTab.propTypes = {
  classNames: PropTypes.object,
  count: PropTypes.number,
  title: PropTypes.string,
  isSelected: PropTypes.bool,
  handleClick: PropTypes.func,
  countColor: PropTypes.string,
  withOutCount: PropTypes.bool,
  isDropdown: PropTypes.bool,
  toggleState: PropTypes.bool,
};
